module.exports = __webpack_public_path__ + "static/logo-white-transparent-93ec122f3553795a775f86e7002f42e4.svg";